// ポータル共通のヘッダ。1 段目にブランドとアカウントメニュー（ログイン中契約・個人設定・切替・ログアウト）、
// 2 段目に画面タブ（tabs を渡したときだけ）。

import { useEffect, useRef, useState, type ReactNode } from "react";
import { Link, NavLink } from "react-router-dom";
import type { Me } from "../lib/api";
import { signOut } from "../lib/auth";

export function AppHeader({ email, contractId, contractName, tabs }: { email: string; contractId?: string; contractName?: string; tabs?: ReactNode }) {
  return (
    <header className="app">
      <div className="bar">
        <span className="brand">シフラ</span>
        <span className="spacer" />
        <AccountMenu email={email} contractId={contractId} contractName={contractName} />
      </div>
      {tabs && <nav className="tabs">{tabs}</nav>}
    </header>
  );
}

/** 契約を選ぶ前の画面（選択・作成・システム設定）のヘッダ。system-admin にだけタブを出す。 */
export function SystemHeader({ me }: { me: Me }) {
  const tabs = me.platformRole === "system-admin" ? (
    <>
      <NavLink to="/select">契約選択</NavLink>
      <NavLink to="/contracts/new">契約を作成</NavLink>
      <NavLink to="/system" end>システム設定</NavLink>
      <NavLink to="/system/admins">システム管理者</NavLink>
    </>
  ) : undefined;
  return <AppHeader email={me.email} tabs={tabs} />;
}

/** 1 段目右。契約選択後は契約名、選択前は email を表示し、クリックでメニューを開く。 */
function AccountMenu({ email, contractId, contractName }: { email: string; contractId?: string; contractName?: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const label = contractName ?? email;

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div className="contract-menu" ref={ref}>
      <button type="button" className="contract-current" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="avatar" aria-hidden>{label.slice(0, 1).toUpperCase()}</span>
        {label}
      </button>
      {open && (
        <div className="menu" role="menu">
          <div className="menu-head">
            {contractName && <div className="menu-contract">{contractName}</div>}
            <div className="muted">{email}</div>
          </div>
          {contractId && <Link to={`/c/${contractId}/profile`} role="menuitem" onClick={() => setOpen(false)}>個人設定</Link>}
          {contractName && <Link to="/select" role="menuitem" onClick={() => setOpen(false)}>契約を切り替える</Link>}
          <a href="#" role="menuitem" onClick={(e) => { e.preventDefault(); void signOut(); }}>ログアウト</a>
        </div>
      )}
    </div>
  );
}
